import type { IncidentFieldRule } from './types';

export const positiveObservationFieldRules: IncidentFieldRule[] = [
    {
        key: 'subCategory',
        label: 'What kind of positive observation is this?',
        description: 'Select the type of positive observation.',
        order: 80,
    },
    {
        key: 'observationCategory',
        label: 'Which category does this observation fall under?',
        description: 'Select the category that best fits this observation.',
        order: 90,
    },
    {
        key: 'typeOfSafeBehaviour',
        label: 'What type of safe behaviour was observed?',
        description: 'Select the type of safe behaviour, e.g. correct PPE use, proper procedure.',
        order: 100,
    },
    {
        key: 'typeOfSafeBehaviourExplanation',
        label: 'Please describe the safe behaviour observed',
        description: 'Provide details about the safe behaviour and its context.',
        order: 110,
        kind: 'textarea',
    },
    {
        key: 'procedureFollowedAppropriately',
        label: 'Which procedure was followed correctly?',
        description: 'Enter the name or reference of the procedure that was followed.',
        order: 120,
    },
];
